import { Heading } from '@strata/react-page-templates';
import { type ReactNode } from 'react';

interface PageProps {
    pageTitle: string;
    pageDescription: ReactNode;
    pageContent: ReactNode;
}

export const Page = ({ pageTitle, pageDescription, pageContent }: PageProps) => (
    <div className="sds_page">
        <Heading text={pageTitle} />
        <div className="sds_page__description">{pageDescription}</div>
        {pageContent}
    </div>
);
